var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CustomAttributeDataKeys, getConfig, } from "@jti/fe-common";
import { getUser } from "../../utils";
import { CasBaseApi } from "./CasBaseApi";
import { EndpointPlaceholders, Endpoints, EvoEndpoints } from "./CasEndpoints";
export const defaultData = {
    [CustomAttributeDataKeys.NewsletterPreferences]: {
        marketingEmailsEnabled: false,
    },
    [CustomAttributeDataKeys.TextMessagePreferences]: {
        marketingSmsEnabled: false,
    },
};
export const sortCustomAttributes = (customAttributes) => {
    const withEmptyDisplayAfter = customAttributes.filter(({ display_after }) => !display_after);
    if (withEmptyDisplayAfter.length === 0) {
        console.warn("Wrong configuration - cannot sort custom attributes (using default order)");
        return customAttributes;
    }
    const withDisplayAfter = customAttributes.filter(({ display_after }) => display_after);
    const results = [...withEmptyDisplayAfter];
    let iteration = 0;
    while (iteration < withDisplayAfter.length) {
        const index = results.findIndex(({ code }) => code === withDisplayAfter[iteration].display_after);
        if (index >= 0) {
            results.splice(index + 1, 0, withDisplayAfter[iteration]);
            withDisplayAfter.splice(iteration, 1);
            iteration = 0;
        }
        else {
            iteration++;
        }
    }
    if (withDisplayAfter.length) {
        console.warn("Wrong configuration - circular dependency in custom attributes or typo in display_after (using default order)");
        return customAttributes;
    }
    return results;
};
export class CasCustomAttrsApi extends CasBaseApi {
    constructor(baseUrl, tenantToken, ciamToken, userUuid) {
        super(baseUrl, tenantToken, ciamToken, userUuid);
        this.tenantToken = tenantToken;
        this.ciamToken = ciamToken;
        this.userUuid = userUuid;
        this.name = "CasCustomAttrsApi";
    }
    static init() {
        const config = getConfig();
        const user = getUser();
        return new CasCustomAttrsApi(config.CAS_URL, config.CAS_X_DES_AK_TENANT_TOKEN, user.ciam_token, user.uuid || "");
    }
    preparePath(path) {
        return path.replace(EndpointPlaceholders.UUID, this.userUuid);
    }
    setUserId(userUuid) {
        this.userUuid = userUuid;
    }
    getUserId() {
        return this.userUuid;
    }
    setCiamToken(ciamToken) {
        this.ciamToken = ciamToken;
        this.setCommonHeader("X-DES-CONSUMER-IAM-TOKEN", this.ciamToken);
    }
    getCustomAttributes() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isEvo) {
                const { custom_attributes, statusCode } = yield this.request(this.replaceUuid(EvoEndpoints.MarketCustomAttrsUrl), {
                    method: "GET",
                }, true);
                return Promise.resolve({
                    data: this.prepareEvoCustomAttributes(custom_attributes),
                    statusCode,
                });
            }
            return this.request(Endpoints.MarketCustomAttrsUrl, {
                method: "GET",
            });
        });
    }
    write(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const useRecaptchaInRequest = true;
            if (this.isEvo) {
                const customer = yield this.request(this.preparePath(EvoEndpoints.CustomAttrsUrl), {
                    body: JSON.stringify(data),
                    method: "PATCH",
                }, useRecaptchaInRequest);
                return Promise.resolve({
                    dob: customer.date_of_birth,
                    email: customer.email,
                    firstname: customer.first_name,
                    lastname: customer.last_name,
                });
            }
            const { customer } = yield this.request(this.preparePath(Endpoints.CustomAttrsUrl), {
                body: JSON.stringify({
                    custom_attributes: data,
                }),
                method: "PATCH",
            }, useRecaptchaInRequest);
            return Promise.resolve({
                dob: customer.dob,
                email: customer.email,
                firstname: customer.firstname,
                lastname: customer.lastname,
            });
        });
    }
    getIsUserHasComplaints() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const useRecaptchaInRequest = true;
            const response = yield this.request(`/users/${this.userUuid}/complaints`, { method: "GET" }, useRecaptchaInRequest);
            return (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.has_complaints;
        });
    }
}
//# sourceMappingURL=CasCustomAttrsApi.js.map